import Rellax from 'rellax';
import { debounce, map } from 'lodash';

const parallax = ($) => {
  /* global document, window */
  // Parallax half images
  window.parallaxImages = [];
  // Parallax CTA's use the Rellax library to do their thing.
  const parallaxCTA = document.querySelectorAll('.paragraph--type-call-to-action.width-full');
  if (parallaxCTA) {
    map(parallaxCTA, (component) => {
      const img = component.querySelector('img');

      /* eslint-disable no-new */
      window.parallaxImages.push(new Rellax(img, {
        center: true,
        horizontal: false,
        round: false,
        speed: -3,
        vertical: true,
      }));
    });
  }

  // When the window is resized, refresh all of the parallax components.
  const refreshParallaxComponents = () => {
    map(window.parallaxImages, item => item.refresh());
  };
  window.addEventListener('resize', debounce(refreshParallaxComponents, 200));
  $(window).ajaxComplete(refreshParallaxComponents);
};

export default parallax;
